import{RestLayoutService}from"@sitecore-jss/sitecore-jss-react";import styled from"styled-components";export const H1Tag=styled.h1`
  position: absolute;
  left: -10000px;
  width: 1px;
  height: 1px;
  overflow: hidden;
`;export const getRouteData=(e,t,s)=>new RestLayoutService({apiKey:s.sitecoreApiKey,siteName:s.jssAppName}).fetchLayoutData(e,t).catch((e=>e.response&&404===e.response.status&&e.response.data?e.response.data:(console.error("Route data fetch error",e,e.response),null)));